/**
 * 查询策略基类
 *
 * @export
 * @class QueryBase
 */
export default class QueryBase {
  constructor() {
    this.dbController = null;
    this.cid = '';
  }

  async query(start, end) {}

  get type() {
    return this.constructor.name;
  }
}
